import { Routes, Route } from 'react-router-dom';
import { Layout } from './layout';
import { routes } from './routes'; 

function Router() {

  const allRoutes = [
    ...routes, 
  ];

  return (
    <>
      <Routes>
        <Route element={<Layout />}>
          {allRoutes.map(({ path, element }) => (
            <Route
              key={path}
              path={path}
              element={element}
            />
          ))}
        </Route>
      </Routes>
    </>
  );
}

export default Router;